import { CountUp } from "countup.js";

(function () {
  document.body.classList.add("rapport-annuel");

  const drawChart = (el) => {
    const canvas = el.querySelector("canvas");
    const ctx = canvas.getContext("2d");

    const r = 2;
    const d = 2 * r;
    const elementsX = 30;
    const elementsY = 40;
    const colors = ["#333333", "#999999", "#f4beba", "#e97f77", "#da2a1c"];

    const { width } = canvas;

    const gapX = (width - elementsX * d) / (elementsX - 1);

    canvas.height = Math.ceil(elementsY * d + (elementsY - 1) * gapX);

    // fix blurry canvas
    canvas.style.width = `${canvas.width}px`;
    canvas.style.height = `${canvas.height}px`;
    canvas.width = 2 * canvas.width;
    canvas.height = 2 * canvas.height;
    ctx.scale(2, 2);

    const getIndices = (data) => {
      const total = data.reduce((a, b) => a + b, 0);
      const cells = elementsX * elementsY;
      const get = (n) => (cells * n) / total;
      let xs = data.map(get);
      xs = xs.map((f) => Math.round(f));
      return xs;
    };

    const data = el.dataset.values
      .split(",")
      .map((x) => x.trim())
      .map((x) => parseInt(x));

    let xs = getIndices(data);

    const colorsChange = xs.reduce((acc, x, idx) => {
      idx === 0 ? acc.push(x) : acc.push(acc[idx - 1] + x);
      return acc;
    }, []);

    function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
    }

    function hexToRGB(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    }

    const draw = ({ x, y, now, past, color, duration, opacity }) => {
      const step = now - past;
      const newOpacity = opacity + step / duration;

      ctx.fillStyle = hexToRGB(color, newOpacity);
      ctx.beginPath();
      ctx.clearRect(x - r, y - r, d, d);
      ctx.arc(x, y, r, 0, 2 * Math.PI);
      ctx.fill();

      if (newOpacity < 1) {
        window.requestAnimationFrame((newNow) =>
          draw({
            x,
            y,
            now: newNow,
            past: now,
            color,
            duration,
            opacity: newOpacity,
          })
        );
      }
    };

    const createCircle = (i, j, index) => {
      const past = performance.now();
      const duration = getRandomInt(200, 3000);
      const color = colors[index] || "#000000";
      const x = i * d + i * gapX + r;
      const y = j * d + j * gapX + r;

      window.requestAnimationFrame((now) => {
        draw({ x, y, now, past, color, duration, opacity: -0.5 });
      });
    };

    let index = 0;

    for (let j = 0; j < elementsY; j++) {
      for (let i = 0; i < elementsX; i++) {
        createCircle(i, j, index);
        const cellId = i + 1 + j * elementsX;
        if (cellId === colorsChange[index]) {
          index++;
        }
      }
    }
  };

  const easingFn = function (t, b, c, d) {
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (tc + -3 * ts + 3 * t);
  };

  const options = {
    duration: 2,
    easingFn,
    useGrouping: false,
    separator: "",
  };

  ScrollTrigger.batch(".chart", {
    start: "top 75%",
    end: "bottom 50%+=100px",
    once: true,
    onEnter: (xs) => {
      for (let i = 0; i < xs.length; i++) {
        const el = xs[i];

        const values = el.dataset.values
          .split(",")
          .map((x) => x.trim())
          .map((x) => parseInt(x));

        const count = values.reduce((sum, x) => sum + x, 0);

        setTimeout(() => {
          drawChart(el);
          new CountUp(el.querySelector(".data"), count, options).start();
        }, i * 300);
      }
    },
  });
})();
